<div class="tags-container">
  <app-tag
    [class]="statusTagClass()"
    [tag]="tag()"
    [tp]="isDdsStatusUpdateFailed() ? statusErrorTooltipContent : null"
  ></app-tag>
</div>

<ng-template #statusErrorTooltipContent>
  <p>
    {{ translations.statusErrorTooltipContent }}
  </p>
  <p>
    {{ translations.statusRetrievedDate }}
    {{ lastStatusUpdate() | localTime }}.
  </p>
</ng-template>
